define('app/dashboard/DashboardWidgetTypes',{
	KPI: {
		label: 'KPI',
		value: 'KPI'
	},
	DONUT: {
		label: 'Donut Chart',
		value: 'DONUT'
	},
	TOP10: {
		label: 'Top 10 List',
		value: 'TOP10'
	},
	LINECHART: {
		label: 'Line Chart',
		value: 'LINECHART'
	},
	STACKEDBARCHART: {
		label: 'Stacked Bar Chart',
		value: 'STACKEDBARCHART'
	},
	BARCHART: {
		label: 'Bar Chart',
		value: 'BARCHART'
	},
	PIECHART: {
		label: 'Pie Chart',
		value: 'PIECHART'
	},
	SCATTERPLOT: {
		label: 'Scatter Plot',
		value: 'SCATTERPLOT'
	}
});

